window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
import './oneui/app';
import 'alpinejs'
import 'summernote';
window.initSummernote = function () {
    $('.summernote').summernote({
        height: 200,
        tabsize: 2,
        followingToolbar: true,
        toolbar: [
            ['style', ['style', 'bold', 'italic', 'underline', 'clear']],
            ['font', ['strikethrough', 'superscript', 'subscript']],
            ['para', ['ul', 'ol', 'paragraph', 'hr']],
            ['insert', ['picture', 'link', 'video']]
        ],
        callbacks: {
            onImageUpload: function (image, editor, welEditable) {
                var data = new FormData();
                data.append("image", image[0]);
                $.ajax({
                    data: data,
                    dataType: 'json',
                    type: "POST",
                    url: "/admin/media/upload",
                    cache: false,
                    contentType: false,
                    processData: false,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        $('.summernote').summernote('editor.insertImage', data.link);
                    },
                });
            }
        }
    });
}

import '@nextapps-be/livewire-sortablejs';

jQuery(function () {
    One.helpers(['ckeditor', 'summernote']);
    window.initSummernote();
});

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
